document.documentElement.classList.remove('no-js');

document.addEventListener('click', function(e){
  const thumb=e.target.closest('[data-product-thumb]');
  if(thumb){
    const gallery=thumb.closest('[data-product-gallery]');
    const main=gallery&&gallery.querySelector('[data-product-main-image]');
    if(main){
      main.src=thumb.dataset.fullImage;
      main.srcset='';
      main.alt=thumb.dataset.alt||main.alt;
      gallery.querySelectorAll('[data-product-thumb]').forEach(t=>t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
  }
  const minus=e.target.closest('[data-qty-minus]');
  const plus=e.target.closest('[data-qty-plus]');
  if(minus||plus){
    const stepper=(minus||plus).closest('.quantity-stepper');
    const input=stepper&&stepper.querySelector('[data-qty-input]');
    if(input){
      const min=parseInt(input.min||'1',10);
      const now=parseInt(input.value||'1',10);
      input.value=minus?Math.max(min,now-1):now+1;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }
});

document.addEventListener('change', function(e){
  if(e.target.matches('[data-variant-radio]')){
    const radio=e.target;
    const root=radio.closest('[data-product-root]');
    if(!root)return;
    root.querySelectorAll('.variant-card').forEach(card=>card.classList.remove('is-selected'));
    radio.closest('.variant-card')?.classList.add('is-selected');
    const price=root.querySelector('[data-product-price]');
    const stickyPrice=root.querySelector('[data-sticky-price]');
    const compare=root.querySelector('[data-product-compare]');
    const selected=root.querySelector('[data-selected-variant]');
    const stock=root.querySelector('[data-stock-state]');
    const atc=root.querySelector('[data-add-to-cart]');
    if(price&&radio.dataset.price)price.textContent=radio.dataset.price;
    if(stickyPrice&&radio.dataset.price)stickyPrice.textContent=radio.dataset.price;
    if(compare){compare.textContent=radio.dataset.compare||'';compare.style.display=radio.dataset.compare?'inline':'none';}
    if(selected)selected.textContent=radio.dataset.title||'';
    const available=radio.dataset.available==='true';
    if(stock){stock.textContent=available?'In stock':'Sold out';stock.classList.toggle('is-out',!available);}
    if(atc){atc.disabled=!available;atc.textContent=available?'Add to cart':'Sold out';}
  }
  if(e.target.matches('[data-variant-select]')){
    const opt=e.target.options[e.target.selectedIndex];
    const root=e.target.closest('[data-product-root]');
    if(!root)return;
    const price=root.querySelector('[data-product-price]');
    const compare=root.querySelector('[data-product-compare]');
    if(price&&opt.dataset.price)price.textContent=opt.dataset.price;
    if(compare){compare.textContent=opt.dataset.compare||'';compare.style.display=opt.dataset.compare?'inline':'none';}
  }
});
